import * as Gantt from "./core/gantt_factory";

const w = window as any;
w.Gantt = Gantt;
w.gantt = Gantt.getGanttInstance();
